import React, { useMemo } from "react";
import NewUiBanner from "./NewUiBanner";
import TwoFactorAuthBanner from "./TwoFactorAuthBanner";
import { useSelector } from "react-redux";

const DashboardBanner = ({ isWhiteLabel }) => {
  const auth = useSelector((state) => state.auth);
  const country = useMemo(() => {
    return auth.selectedHotel.country;
  }, [auth]);
  const slotType = useMemo(() => {
    return auth.selectedHotel.slotType;
  }, [auth]);

  return (
    <div>
      {/* <TwoFactorAuthBanner /> */}
      {!isWhiteLabel && slotType === "NOON" && <NewUiBanner />}
    </div>
  );
};

export default DashboardBanner;
